// extracted by mini-css-extract-plugin
export default {"emotionsListWrapper":"EmotionsList_emotionsListWrapper__QGWl6"};